// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteContact } from './siteContact.js';
import type { TenantHealthCarePracticePortalSiteDetails } from './tenantHealthCarePracticePortalSiteDetails.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TenantHealthCarePracticePortalSiteRequestModel {
    'siteDetails': TenantHealthCarePracticePortalSiteDetails | null;
    'siteContact': SiteContact | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TenantHealthCarePracticePortalSiteRequestModel>> = [
        {
            "name":     "siteDetails",
            "baseName": "siteDetails",
            "type":     "TenantHealthCarePracticePortalSiteDetails"
        },
        {
            "name":     "siteContact",
            "baseName": "siteContact",
            "type":     "SiteContact"
        },
    ];

    static getAttributeTypeMap() {
        return TenantHealthCarePracticePortalSiteRequestModel.attributeTypeMap;
    }
}
